export const MEDIA_EMPTY_LABEL = '-----';
export const MEDIA_EMPTY_VALUE = '';

export const MEDIA_IMAGE_LABEL = 'Image';
export const MEDIA_IMAGE_VALUE = 'image';

export const MEDIA_AUDIO_LABEL = 'Audio';
export const MEDIA_AUDIO_VALUE = 'audio';

export const MEDIA_VIDEO_LABEL = 'Video';
export const MEDIA_VIDEO_VALUE = 'video';

export const MEDIA_MAP_LABEL = 'Map';
export const MEDIA_MAP_VALUE = 'map';

export const MEDIA_PDF_LABEL = 'Pdf';
export const MEDIA_PDF_VALUE = 'application/pdf';

const mediaResourcesTypes = [
  {
    text: MEDIA_EMPTY_LABEL,
    value: MEDIA_EMPTY_VALUE,
  },
  {
    text: MEDIA_IMAGE_LABEL,
    value: MEDIA_IMAGE_VALUE,
  },
  {
    text: MEDIA_AUDIO_LABEL,
    value: MEDIA_AUDIO_VALUE,
  },
  {
    text: MEDIA_VIDEO_LABEL,
    value: MEDIA_VIDEO_VALUE,
  },
  {
    text: MEDIA_MAP_LABEL,
    value: MEDIA_MAP_VALUE,
  },
  {
    text: MEDIA_PDF_LABEL,
    value: MEDIA_PDF_VALUE,
  },
];

export default mediaResourcesTypes;
